import moment from 'moment';
import React, { Component } from 'react';
import { BsFormControl, BsFormSelect, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import HiddenInput from '../../collection/inputs/HiddenInput';
import { apiForm, apiGet } from '../../utils/api';

export default function HorasExtraModal(props) {
    const isNew = props.idHorasExtra < 1;

    const updateData = async () => await apiGet("horasextras/get/" + props.idHorasExtra);

    const checkData = formData => {
        let errors = {};
        // Fecha y horas
        const fecha = formData.get("fecha");
        const horaInicio = formData.get("horaInicio");
        const horaFin = formData.get("horaFin");
        if (!fecha) {
            errors["fecha"] = "Campo obligatorio";
        }
        if (!horaInicio) {
            errors["horaInicio"] = "Campo obligatorio";
        }
        if (!horaFin) {
            errors["horaFin"] = "Campo obligatorio";
        }
        if (fecha) {
            if (horaInicio) {
                const fhi = moment(fecha + ' ' + horaInicio);
                if (!fhi.isValid(fhi)) {
                    errors["horaInicio"] = "Fecha y hora no válidas";
                }
            }
            if (horaFin) {
                const fhf = moment(fecha + ' ' + horaFin);
                if (!fhf.isValid(fhf)) {
                    errors["horaFin"] = "Fecha y hora no válidas";
                }
            }
        }
        // Cliente
        const cliente = formData.get("cliente");
        if (!cliente) {
            errors["cliente"] = "Campo obligatorio";
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("horasextras/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nuevas horas extra" : "Editar horas extra"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <HorasExtraForm />
        </BsModalForm>
    );
}

class HorasExtraForm extends Component {

    constructor(props) {
        super(props);
        this.state = { listClientes: null };
    }

    async componentDidMount() {
        const list = await apiGet("clientes/list");
        this.setState({ listClientes: list });
    }

    renderForm() {
        const data = this.props.data;
        const errors = this.props.errors;
        return <>
            <BsFormControl
                /* Fecha */
                label="Fecha" name="fecha"
                value={data.fecha} error={errors.fecha}
                type="date" />
            <BsFormControl
                /* Hora inicio */
                label="Inicio" name="horaInicio"
                value={data.horaInicioStr} error={errors.horaInicio}
                className="mt-3" type="time" />
            <BsFormControl
                /* Hora fin */
                label="Final" name="horaFin"
                value={data.horaFinStr} error={errors.horaFin}
                className="mt-3" type="time" />
            <BsFormSelect
                /* Cliente */
                label="Cliente" name="cliente"
                value={data.cliente} error={errors.cliente}
                options={this.state.listClientes}
                className="mt-3" />
            <BsFormControl
                /* Comentario */
                label="Comentario" name="comentario"
                value={data.comentario} error={errors.comentario}
                className="mt-3" maxLength="250" as="textarea" />
        </>;
    }

    render() {
        return !(this.state.listClientes) ?
            <Loading /> : this.renderForm();
    }
}
